<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col>
          <b-row>
            <b-col sm="12">
              <b-card header-bg-variant="primary">
                <div slot="header">
                  <strong>
                    รายชื่อบัณฑิต<font color="red"><u>ไม่ได้</u></font>บันทึกข้อมูล
                    <div v-if="thaistudent==2">(ไทยและต่างชาติ)</div>
                    <div v-if="thaistudent==0">(เฉพาะต่างชาติ)</div>
                  </strong>
                </div>
<!--                <b-button type="submit" size="md" class="mr-2" variant="danger" @click="onSubmit">-->
<!--                  <i class="fa fa-file-excel-o"></i> Download Excel-->
<!--                </b-button>-->
                <b-row>
                  <b-col lg="1"></b-col>
                  <b-col lg="10">
                    จำนวน {{ countrow.toLocaleString() }}
                    <b-table striped hover :items="items" :fields="fields"></b-table>
                  </b-col>
                  <b-col lg="1"></b-col>
                </b-row>
                <!-- <b-row>
                  <b-col>ลำดับ</b-col>
                  <b-col>รหัสประจำตัวนักศึกษา</b-col>
                  <b-col>ชื่อ-นามสกุล</b-col>
                  <b-col>สำนักวิชา</b-col>
                  <b-col>ปริญญา</b-col>
                </b-row>

                <div v-for="item in items" v-bind:key="item.DATETOTAL">
                  <b-row>
                    <b-col>{{i+1}}</b-col>
                    <b-col>{{item.STUDENTCODE}}</b-col>
                    <b-col>{{item.STUDENTNAME}} {{item.STUDENTSURNAME}}</b-col>
                    <b-col>{{item.FACULTYNAME}}</b-col>
                    <b-col>{{item.LEVELGROUPNAME }}</b-col>
                  </b-row>
                </div>-->
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="6"></b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";

export default {
  components: {YimoVueEditor},
  name: "CreateGeneral",
  data() {
    return {
      fields: [
        {
          key: "STUDENTCODE",
          label: "รหัสประจำตัวนักศึกษา",
          formatter: "STUDENTCODE"
        },
        {
          key: "STUDENTNAME",
          label: "ชื่อ",
          formatter: "STUDENTNAME"
        },
        {
          key: "STUDENTSURNAME",
          label: "นามสกุล",
          formatter: "STUDENTSURNAME"
        }
        ,
        {
          key: "DEPARTMENTNAME",
          label: "สาขาวิชา",
          formatter: "DEPARTMENTNAME"
        },
        {
          key: "FACULTYNAME",
          label: "สำนักวิชา",
          formatter: "FACULTYNAME"
        },
        {
          key: "LEVELGROUPNAME",
          label: "ปริญญา",
          formatter: "LEVELGROUPNAME"
        }
      ],
      items: [],
      i: 0,
      countrow: 0,
      thaistudent:"",
      facultyid:"",
      level :"",
      deptid :"",
      groupid :"",
      year :"",
    };
  },

  methods: {
    onSubmit(){
      if (!Number.isInteger(this.facultyid)) {
        this.facultyid=0;
      }
      if (!Number.isInteger(this.deptid)) {
        this.deptid=0;
      }
      if (!Number.isInteger(this.groupid)) {
        this.groupid=0;
      }
      this.$router.push("/Excelnotregis?year="+this.year+"&level="+this.level+"&id="+this.facultyid+"&dept="+this.deptid+"&group="+this.groupid);
    },

    getStatistic(thaistudent, facultyid, deptid, groupid,year,level) {
      api
        .getStatisticNotRegis(thaistudent, facultyid, deptid, groupid,year,level)
        .then(res => {
          this.countrow = res.data.data.length;
          this.items = res.data.data;
          // console.log(this.items);
          // console.log(res);
        })
        .catch(err => {
          console.log("getStatistic", err.toString());
        });
    }
  },
  mounted() {
  },
  created() {
    this.facultyid = parseInt(this.$route.query.id);
    this.deptid = parseInt(this.$route.query.dept);
    this.groupid = parseInt(this.$route.query.group);
    this.year = parseInt(this.$route.query.year);
    this.level= parseInt(this.$route.query.level);
    this.thaistudent= parseInt(this.$route.query.thai);
    if (Number.isInteger(this.facultyid)) {
      // console.log("thaistudent",this.thaistudent)
      // console.log("1")
      if (this.thaistudent !=null){
        this.getStatistic(0, this.facultyid, 0, 0, this.year, this.level);
      }else {
        this.getStatistic(2, this.facultyid, 0, 0, this.year, this.level);
      }
    } else {
      if (Number.isInteger(this.deptid)) {
        // console.log("2")
        // console.log("id",this.deptid)
        this.getStatistic(2, 0, this.deptid, this.groupid,this.year,this.level);
      } else {
        // console.log("3")
        this.getStatistic(2, 0, 0, 0,this.year,this.level);
      }
    }
    api.onSetHeader();
  }
};
</script>
<style>
</style>
